import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "t6_table_b" }
const _hoisted_2 = { class: "input_td" }
const _hoisted_3 = { class: "input_td" }
const _hoisted_4 = { class: "input_td" }
const _hoisted_5 = {
  class: "input_td text",
  colspan: "3"
}
const _hoisted_6 = { style: {"float":"left","width":"160px"} }
const _hoisted_7 = { style: {"float":"left","cursor":"pointer"} }
const _hoisted_8 = { class: "tip" }
const _hoisted_9 = { class: "tip_icon" }
const _hoisted_10 = { class: "input_td" }
const _hoisted_11 = { class: "input_td" }
const _hoisted_12 = { class: "input_td" }
const _hoisted_13 = { class: "input_td" }

import { reactive, ref, toRefs } from "vue";
import { useStore } from "vuex";
import { Warning } from '@element-plus/icons-vue';
import cityMapJSON from '@/config/cityMap'


export default /*@__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    publicData:Object
},
  setup(__props, { expose: __expose }) {

const props = __props
const { publicData } = toRefs(props) as any

const cityMap = JSON.parse(JSON.stringify(cityMapJSON))
const tree = ref(null) as any
const changeSelectCityLevel = (address:any) => {
    let nodes = tree.value.getCheckedNodes()
    publicData.value.basicInfo.addressee.regionCode = nodes[0].data.cityCode || ''    //  选中的区划编码
    let selectCityLevel = address //  选择邮寄收件地址用-省市县
    publicData.value.basicInfo.addressee.sendProvince = selectCityLevel[0] || ''
    publicData.value.basicInfo.addressee.sendCity = selectCityLevel[1] || ''
    publicData.value.basicInfo.addressee.sendCounty = selectCityLevel[2] || ''
}

const data = reactive({
    applyCardnumber:'',
    formType: 0,    //  用户表单类型
})

const store = useStore()
const userInfo = store.state.userInfomation

const getFormData = () => {
    return publicData?.value
}
__expose({
    getFormData
})



return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      model: _unref(publicData),
      class: "demo-form-inline",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_1, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[8] || (_cache[8] = _createElementVNode("th", null, "一件事名称", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).oneThing.modelName), 1),
              _cache[9] || (_cache[9] = _createElementVNode("th", null, "所属行业", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).oneThing.hangyeType_dictText), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[10] || (_cache[10] = _createElementVNode("th", null, "申请人姓名", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).basicInfo.preApasinfo.applyname), 1),
              _cache[11] || (_cache[11] = _createElementVNode("th", null, "证件类型", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).basicInfo.preApasinfo.applyCardtype), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[12] || (_cache[12] = _createElementVNode("th", null, "证件号码", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).basicInfo.preApasinfo.contactmanCardnumber2), 1),
              _cache[13] || (_cache[13] = _createElementVNode("th", null, "申报类型", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(userInfo).userType == '1'?'法人':'自然人'), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[14] || (_cache[14] = _createElementVNode("th", null, "联系人姓名", -1)),
              _createElementVNode("td", _hoisted_2, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(publicData).basicInfo.preApasinfo.contactman) = $event))
                }, null, 512), [
                  [_vModelText, _unref(publicData).basicInfo.preApasinfo.contactman]
                ])
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("th", null, "联系人手机", -1)),
              _createElementVNode("td", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(publicData).basicInfo.preApasinfo.telphone) = $event))
                }, null, 512), [
                  [_vModelText, _unref(publicData).basicInfo.preApasinfo.telphone]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[16] || (_cache[16] = _createElementVNode("th", null, "联系人证件类型", -1)),
              _createElementVNode("td", null, _toDisplayString(_unref(publicData).basicInfo.preApasinfo.contactmanCardtype), 1),
              _cache[17] || (_cache[17] = _createElementVNode("th", null, "联系人证件号码", -1)),
              _createElementVNode("td", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(publicData).basicInfo.preApasinfo.contactmanCardnumber) = $event))
                }, null, 512), [
                  [_vModelText, _unref(publicData).basicInfo.preApasinfo.contactmanCardnumber]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[20] || (_cache[20] = _createElementVNode("th", null, "是否需要结果邮递", -1)),
              _createElementVNode("td", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_switch, {
                    modelValue: _unref(publicData).basicInfo.preApasinfoRelation.isJgydStatus,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(publicData).basicInfo.preApasinfoRelation.isJgydStatus) = $event)),
                    size: "large",
                    "active-text": "是",
                    "inactive-text": "否"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_tooltip, { placement: "top" }, {
                    content: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("div", { style: {"width":"300px"} }, [
                        _createElementVNode("div", null, " 结果邮寄免责说明: "),
                        _createElementVNode("div", { style: {"text-indent":"2em"} }, " 本人（或单位）委托中国（河南）自由贸易试验区开封片区综合服务中心通过河南省邮政邮寄， 为了避免引起纠纷特做如下说明，因邮寄出现丢失、破损等现象而造成的无法正常收件的后果，由本人自行负责。 ")
                      ], -1)
                    ]))]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "tip_text" }, " 温馨提示 ", -1)),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(Warning), { class: "icon" })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            (_unref(publicData).basicInfo.preApasinfoRelation.isJgydStatus)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("tr", null, [
                    _cache[21] || (_cache[21] = _createElementVNode("th", null, "收件人姓名", -1)),
                    _createElementVNode("td", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(publicData).basicInfo.preExpress.receiveName) = $event)),
                        maxlength: "20"
                      }, null, 512), [
                        [_vModelText, _unref(publicData).basicInfo.preExpress.receiveName]
                      ])
                    ]),
                    _cache[22] || (_cache[22] = _createElementVNode("th", null, "联系方式", -1)),
                    _createElementVNode("td", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(publicData).basicInfo.preExpress.receivePhone) = $event)),
                        maxlength: "20"
                      }, null, 512), [
                        [_vModelText, _unref(publicData).basicInfo.preExpress.receivePhone]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[23] || (_cache[23] = _createElementVNode("th", null, "城市/区划", -1)),
                    _createElementVNode("td", _hoisted_12, [
                      _createVNode(_component_el_cascader, {
                        style: {"width":"100%","height":"100%","z-index":"2000"},
                        modelValue: _unref(publicData).oneThing.areaCode,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(publicData).oneThing.areaCode) = $event)),
                        options: _unref(cityMap),
                        ref_key: "tree",
                        ref: tree,
                        props: { expandTrigger: 'click',value:'cityName',label:'cityName',children:'counties' },
                        onChange: changeSelectCityLevel
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("th", null, "详细地址", -1)),
                    _createElementVNode("td", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(publicData).basicInfo.preExpress.receiveAddr) = $event)),
                        maxlength: "100"
                      }, null, 512), [
                        [_vModelText, _unref(publicData).basicInfo.preExpress.receiveAddr]
                      ])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})